import { User } from './user.model';


export class UserEdit extends User {
  constructor(currentPassword?: string, newPassword?: string, confirmPassword?: string, confirmEmail?: string) {
    super();

    this.currentPassword = currentPassword;
    this.newPassword = newPassword;
    this.confirmPassword = confirmPassword;
    this.confirmEmail = confirmEmail;
  }

  public currentPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public confirmEmail: string;

}
